import tim from "tim";
import TIM from "tim-js-sdk";
import store from "..";
import session from "@/api/session";
import TYPES from "@/utils/types";
import custAvatar from "@/assets/image/defaultchannellogo.png";
const conversationModules = {
  state: {
    currentConversation: {},
    currentMessageList: [],
    nextReqMessageID: "",
    isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
    conversationList: [],
    toAccount: null,
    currentConversationType: null,
    sign: 1,
    APPID: null,
    UID: null,
    platform: "H5",
    page: 1,
    lastMessageTime: 0,
    isfirst: true,
    isNeedAssignCustomer: true,
    channelname: "",
    headerUrl: custAvatar,
    eval_class: [],
    curQueneNum: 0,
    curSesId: 0,
  },
  getters: {
    totalUnreadCount: (state) => {
      const result = state.conversationList.reduce((count, conversation) => {
        // 当前会话不计算总未读
        if (
          !store.getters.hidden &&
          state.currentConversation.conversationID ===
            conversation.conversationID
        ) {
          return count;
        }
        return count + conversation.unreadCount;
      }, 0);
      // titleNotify(result)
      return result;
    },

    // 用于当前会话的图片预览
    imgUrlList: (state) => {
      return state.currentMessageList
        .filter((message) => message.type === TYPES.MSG_TYPE.IMAGE) // 筛选出没有撤回并且类型是图片类型的消息
        .map((message) => message.content);
    },
  },
  mutations: {
    //获取当前sessionId
    setCurSesId(state, val) {
      state.curSesId = val;
    },
    //获取排队刷新人数
    setCurQueneNum(state, val) {
      state.curQueneNum = val;
    },
    // 获取点踩评价项
    setEvalClass(state, val) {
      state.eval_class = val;
    },
    /**
     * 更新当前会话
     * 调用时机: 切换会话时
     * @param {Object} state
     * @param {Conversation} conversation
     */
    updateCurrentConversation(state, conversation) {
      state.currentConversation = conversation;
      state.currentMessageList = [];
      state.nextReqMessageID = "";
      state.isCompleted = false;
    },
    /**
     * 更新会话列表
     * 调用时机：触发会话列表更新事件时。CONVERSATION_LIST_UPDATED
     * @param {Object} state
     * @param {Conversation[]} conversationList
     */
    updateConversationList(state, conversationList) {
      state.conversationList = conversationList;
    },
    /**
     * 重置当前会话
     * 调用时机：需要重置当前会话时，例如：当前会话是一个群组，正好被踢出群时（被踢群事件触发），重置当前会话
     * @param {Object} state
     */
    resetCurrentConversation(state) {
      state.currentConversation = {};
    },
    /**
     * 将消息插入当前会话列表
     * 调用时机：收/发消息事件触发时
     * @param {Object} state
     * @param {Message[]|Message} data
     * @returns
     */
    pushCurrentMessageList(state, data) {
      if (Array.isArray(data)) {
        state.currentMessageList = data
      } else {
        state.currentMessageList = [...state.currentMessageList, data];
      }
    },

    /**
     * 从当前消息列表中删除某条消息
     * @param {Object} state
     * @param {Message} message
     */
    removeMessage(state, message) {
      const index = state.currentMessageList.findIndex(
        ({ createTime }) => createTime === message.createTime
      );
      if (index >= 0) {
        state.currentMessageList.splice(index, 1);
      }
    },
    reset(state) {
      Object.assign(state, {
        currentConversation: {},
        currentMessageList: [],
        nextReqMessageID: "",
        isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
        conversationList: [],
      });
    },

    // 设置聊天的对方客服账号
    updateConversation(state, payload) {
      state.toAccount = payload.toAccount;
      state.currentConversationType = payload.convType;
    },

    // 是否需要获取客服账号
    setNeedAssignCustomer(state, payload) {
      state.isNeedAssignCustomer = payload.isNeedAssignCustomer;
    },

    // 设置会话的基本参数
    setConversationInfo(state, payload) {
      (state.APPID = payload.APPID),
        (state.UID = payload.UID),
        (state.sign = payload.sign);
    },
    // 设置聊天窗口头部信息以及用户信息
    setHeaderInfo(state, payload) {
      state.channelname = payload.channelname;
      state.headerUrl = payload.headerUrl;
      let linkHtml = document.createElement("link");
      linkHtml.rel = "icon";
      linkHtml.type = "image/x-icon";
      linkHtml.href = state.headerUrl || custAvatar;
      document.head.append(linkHtml);
    },
  },
  actions: {
    /**
     * 获取消息列表
     * 调用时机：打开某一会话时或下拉获取历史消息时
     * @param {Object} context
     * @param {String} conversationID
     */
    getMessageList(context, conversationID) {
      if (context.state.isCompleted) {
        context.commit("showMessage", {
          message: "已经没有更多的历史消息了哦",
          type: "info",
        });
        return;
      }
      const { nextReqMessageID, currentMessageList } = context.state;
      tim
        .getMessageList({ conversationID, nextReqMessageID, count: 15 })
        .then((imReponse) => {
          // 更新messageID，续拉时要用到
          context.state.nextReqMessageID = imReponse.data.nextReqMessageID;
          context.state.isCompleted = imReponse.data.isCompleted;
          // 更新当前消息列表，从头部插入
          context.state.currentMessageList = [
            ...imReponse.data.messageList,
            ...currentMessageList,
          ];
        });
    },

    /**
     * 切换会话
     * 调用时机：切换会话时
     * @param {Object} context
     * @param {String} conversationID
     */
    checkoutConversation(context, conversationID) {
      context.commit("resetCurrentMemberList");
      // 1.切换会话前，将切换前的会话进行已读上报
      if (context.state.currentConversation.conversationID) {
        const prevConversationID =
          context.state.currentConversation.conversationID;
        tim.setMessageRead({ conversationID: prevConversationID });
      }
      // 2.待切换的会话也进行已读上报
      tim.setMessageRead({ conversationID });
      // 3. 获取会话信息
      return tim.getConversationProfile(conversationID).then(({ data }) => {
        // 3.1 更新当前会话
        context.commit("updateCurrentConversation", data.conversation);
        // 3.2 获取消息列表
        context.dispatch("getMessageList", conversationID);
        // 3.3 拉取第一页群成员列表
        if (data.conversation.type === TIM.TYPES.CONV_GROUP) {
          return context.dispatch(
            "getGroupMemberList",
            data.conversation.groupProfile.groupID
          );
        }
        return Promise.resolve();
      });
    },

    /**
     * 获取历史消息
     * @param {*} context
     */
    async getSessionList(context, where) {
      if (context.state.isCompleted) {
        context.commit("showMessage", {
          message: "已经没有更多的历史消息了哦",
          type: "info",
        });
        return;
      }
      const { currentMessageList } = context.state;
      await session
        .getSessionList({
          fromAccount: context.rootState.user.userID,
          page: context.state.page,
          limit: 20,
        })
        .then((res) => {
          if (Array.isArray(res)) {
            context.state.lastMessageTime = res[res.length - 1].create_time;
            let formatRes = [];
            res.reverse().forEach((item) => {
              if (
                item.msg_type != "Typing" &&
                item.msg_type != "CancelTyping"
              ) {
                let newItem = {
                  ID: item.id,
                  sessionId: item.sess_id,
                  headimgurl: item.headimgurl,
                  nickname: item.nickname,
                  content: item.content,
                  sendFrom: item.send_from,
                  state: item.state,
                  type:
                    item.evaluate_msg_type == "2"
                      ? "text-evaluate"
                      : item.msg_type, //满意度消息类型 text-evaluate
                  evaluate_msg:
                    item.evaluate_msg_type == "2"
                      ? "1"
                      : item.evaluate_msg_type, //是否是满意度消息 1--是满意度 其他--不是
                  evaluation_way: item.evaluate_type || "1", //满意度评价类型 1--数字 2--星星 3--表情
                  satisfaction_is_expired: item.satisfaction_is_expired || "1", //满意度评价是否过期 1--过期 2--未过期
                  grade: item.grade || "0", //满意度评价 0--未评价 1--非常好 2--好 3--不好 4--差劲
                  isRevoked:
                    item.evaluate_msg_type == "2" ? true : item.state == 4,
                  isReaded: true,
                  conversationType: "C2C",
                  createTime: new Date(
                    item.create_time.replace(/-/g, "/")
                  ).getTime(),
                };
                if (item.evaluate_msg == "1") {
                  let newcontent = JSON.parse(newItem.content);
                  newcontent["se_id"] = item.sess_id;
                  newItem["content"] = newcontent;
                }
                context.dispatch("formatSendTime", newItem);
                formatRes.push(newItem);
              }
            });
            context.state.currentMessageList = [
              ...formatRes,
              ...currentMessageList,
            ];
            context.state.page++;
          } else {
            context.state.isCompleted = true;
          }
          // 添加商品链接
          // if(!context.state.isfirst) return
          // let goodsItem = {
          //   content: JSON.stringify({
          //     name: '老干妈拌企鹅肉',
          //     img: 'http://i.ce.cn/ce/2012sy/dt/201601/30/W020160130454873265861.jpg',
          //     description: '好吃又好玩',
          //     price: '￥1600万',
          //     showSendBtn: true,
          //   }),
          //   type: TYPES.MSG_TYPE.GOODS,
          //   isSupport: true,
          //   createTime: new Date().getTime(),
          // }
          // context.state.currentMessageList.push(goodsItem)
          // context.state.isfirst = false
        })
        .catch((err) => {});
      if (where === "auto") {
        await session
          .sendWelcome({
            appid: context.state.APPID,
            enterid: context.rootState.user.enterid,
            fromAccount: context.rootState.user.userID,
            oid: context.state.sign,
            isAnonymity: context.rootState.user.anonymity ? "1" : "0",
          })
          .then((res) => {
            const { eval_class, head_img, nickname, hot, remind } = res;
            store.commit("setEvalClass", eval_class);
            //欢迎语
            if (remind) {
              context.state.currentMessageList.push({
                content: remind,
                headimgurl: head_img,
                type: "text",
                isRevoked: false,
              });
            }
            // console.log(context.state.currentMessageList);
            //热门问题
            if (hot.length > 0) {
              context.state.currentMessageList.push({
                evaluate_msg: "3",
                content: hot,
                isRevoked: false,
                type: "text",
              });
            }
          })
          .catch((err) => {});
      }
    },

    /**
     * 格式化显示时间
     * 1、当天的消息，以300000毫秒（每5分钟）为一个跨度的显示时间；
     * 2、超过一天，显示’昨天 + 00:00‘
     * 3、超过两天，显示’xxxx年xx月xx日 00:00‘。
     * @param {*} item
     */
    formatSendTime(context, item) {
      let curTime = new Date(),
        todayTime = Date.parse(
          `${curTime.getFullYear()}/${curTime.getMonth() +
            1}/${curTime.getDate()} 00:00:00`
        ),
        op = (num) => (String(num).length === 1 ? `0${num}` : num);
      if (item.createTime === null) return;
      if (String(item.createTime).length == 10) {
        item.createTime = item.createTime * 1000;
      }
      // 间隔大于5分钟才格式化时间
      if (item.createTime - context.state.lastMessageTime < 300000) {
        return;
      } else {
        context.state.lastMessageTime = item.createTime;
      }
      let timestamp = new Date(item.createTime),
        diffTime = Math.floor((todayTime - item.createTime) / 1000),
        diffDay = Math.ceil(diffTime / 86400),
        diffDate = `${op(timestamp.getHours())}:${op(timestamp.getMinutes())}`;
      switch (diffDay) {
        case 0:
          item.formatTime = diffDate;
          break;
        case 1:
          item.formatTime = `昨天 ${diffDate}`;
          break;
        default:
          item.formatTime = `${timestamp.getFullYear()}年${op(
            timestamp.getMonth() + 1
          )}月${op(timestamp.getDate())}日 ${diffDate}`;
          break;
      }
    },
  },
};

export default conversationModules;
